import en from './en.json';
import de from './de.json';
import it from './it.json';
import es from './es.json';

import { DEFAULT_LOCALE } from '../config';

export const MESSAGES = {
  en,
  de,
  it,
  es,
};

export const getMessages = (locale) => MESSAGES[locale] ?? MESSAGES[DEFAULT_LOCALE];
